import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { TimeConstants } from '../../../constants/time';
import { Rating } from '../../../Member/review/ReviewFilter';
import { handleError } from '../../../utils/common';
import { useAlertModal } from '../../../utils/hook/hook';
import { ReviewsRatingResponse } from '../dto/response/reviews-rating.res.dto';
import { ReviewsApi } from '../reviews.api';

/**
 * 리뷰 평균 평점 조회를 위한 React Query 훅
 * 전체 리뷰와 집밥일기의 평균 평점 및 개수를 조회합니다.
 */
export const useReviewsRatingQuery = (
  options?: Omit<
    UseQueryOptions<ReviewsRatingResponse>,
    'queryKey' | 'queryFn' | 'meta'
  >,
) => {
  const { openAlertModal } = useAlertModal();

  const queryResult = useQuery({
    queryKey: ReviewsApi.queryKeys.averageRating(),
    queryFn: () => ReviewsApi.getAverageRating(),
    staleTime: TimeConstants.FIVE_MINUTES,
    meta: {
      onError: (error: unknown) =>
        handleError(openAlertModal, error, '리뷰/집밥일기 개수 가져오기'),
    },
    ...options,
  });

  const rating: Rating = queryResult.data
    ? {
        count:
          queryResult.data.subscriptionReviewCount +
          queryResult.data.cookDiaryCount,
        subscriptionReviewCount: queryResult.data.subscriptionReviewCount,
        cookDiaryCount: queryResult.data.cookDiaryCount,
        rating: Math.round(queryResult.data.rating * 10) / 10,
      }
    : {
        count: 0,
        rating: 0,
        subscriptionReviewCount: 0,
        cookDiaryCount: 0,
      };

  return {
    ...queryResult,
    rating,
    count: rating.count,
    ratingValue: rating.rating,
  };
};
